import React from 'react';
import { faPhone, faEnvelope, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { useBrandingData } from './DataProviders';
import Icon from './Icon';
import { useReturnPolicyDialog } from './ReturnPolicyDialog';
import { BtLink } from './BtLink';


export function ContactPhone({ className }:{
  className?: string
}) {
  const { phone, toggles: { show_phone } } = useBrandingData();

  if( !show_phone || !phone ) {
    return null;
  }

  return <BtLink href={`tel:${phone}`} className={className}>
    <span className="text">{phone}</span> <Icon icon={faPhone} className="icon" />
  </BtLink>;
}

export function ContactEmail({ className }:{
  className?: string
}) {
  const { email, toggles: { show_email } } = useBrandingData();

  if( !show_email || !email ) {
    return null;
  }

  return <BtLink href={`mailto:${email}`} className={className}>
    <span className="text">{email}</span> <Icon icon={faEnvelope} className="icon" />
  </BtLink>;
}

export function ReturnPolicyLink({ className }:{
  className?: string
}) {
  const { return_policy, toggles: { show_return_policy } } = useBrandingData();
  const { toggle }  = useReturnPolicyDialog();

  if( !show_return_policy || !return_policy ) {
    return null;
  }

  return <BtLink onClick={toggle} className={className}>
    <span className="text">
      <FormattedMessage description="returnPolicyLinkText" defaultMessage="Return Policy" />
    </span>
    <Icon icon={faUndo} className="icon" />
  </BtLink>;
}

export default function ContactInfo({ className }:{
  className?: string
}) {
  const { phone, email, return_policy, toggles={} } = useBrandingData();

  const showPhone = toggles.show_phone && phone;
  const showEmail = toggles.show_email && email;
  const showReturnPolicy = toggles.show_return_policy && return_policy;

  if( !showPhone && !showEmail && !showReturnPolicy ) {
    return null;
  }

  return <div className={className}>
    <ContactPhone className="contactPhone" />
    <ContactEmail className="contactEmail" />
    <ReturnPolicyLink className="returnPolicyLink" />
  </div>;
}